export default __webpack_public_path__ + "static/media/cdmCasesUncropped.51e70b55.png";